import { render, staticRenderFns } from "./RedirectCreate.vue?vue&type=template&id=1c6dca20"
import script from "./RedirectCreate.vue?vue&type=script&lang=js"
export * from "./RedirectCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports